/**
 * @file 爆款裂变 store
 */

const state = {
    // 爆款视频
    hotVideo: null,
    // 替换数字人列表
    digitalHumanList: [],
    // 替换素材列表
    materialList: [],
    // 前贴素材列表
    prePasteList: [],
    // 数字人裂变最大数量
    MAX_DIGITAL_HUMAN_COUNT: 5,
    // 前贴素材裂变最大数量
    MAX_PRE_PASTE_COUNT: 5,
    // 是否使用原音频
    useOriginalAudio: true,
    // 是否组合裂变
    combineFission: false
};

const mutations = {
    SET_HOT_VIDEO(state, video) {
        state.hotVideo = video;
    },
    SET_DIGITAL_HUMAN_LIST(state, list) {
        state.digitalHumanList = list;
    },
    SET_MATERIAL_LIST(state, list) {
        state.materialList = list;
    },
    SET_PRE_PASTE_LIST(state, list) {
        state.prePasteList = list;
    },
    SET_FIELD(state, {key, value}) {
        state[key] = value;
    }
};

const actions = {
    setHotVideo({commit}, video) {
        commit('SET_HOT_VIDEO', video);
    },
    setDigitalHumanList({commit}, list) {
        commit('SET_DIGITAL_HUMAN_LIST', list);
    },
    setMaterialList({commit}, list) {
        commit('SET_MATERIAL_LIST', list);
    },
    setPrePasteList({commit}, list) {
        commit('SET_PRE_PASTE_LIST', list);
    },
    setUseOriginalAudio({commit}, value) {
        commit('SET_FIELD', {key: 'useOriginalAudio', value});
    },
    setCombineFission({commit}, value) {
        commit('SET_FIELD', {key: 'combineFission', value});
    },
    // 批量更新
    batchUpdate({commit}, payload) {
        Object.keys(payload).forEach(key => {
            commit('SET_FIELD', {key, value: payload[key]});
        });
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions
};
